import {
  productCategories,
  productMaterials,
  productPackagingMaterials
} from "@aclymatepackages/lists";
import { batteryTypes } from "@aclymatepackages/products";

const MATERIAL_LABELS = Object.fromEntries(
  [
    ...productMaterials.map(({ id, label }) => [id, label]),
    ...productPackagingMaterials.map(({ id, label }) => [id, label]),
    ...batteryTypes.map(({ type, label }) => [type, label]),
    ["electronics", "Electronics"]
  ]
);

const materialLabel = ({ type, weight, weightUnit }) => {
  const label = MATERIAL_LABELS[type] || type || "?";
  return weight ? `${label} (${weight}${weightUnit === "%" ? "%" : "g"})` : label;
};

export const formatSubcategoryLabel = (category, subcategory) => {
  const subcategoryEntry = productCategories
    .find(({ id }) => id === category)
    ?.subcategories?.find(({ id }) => id === subcategory);
  return subcategoryEntry?.label || subcategory || null;
};

export const formatProductWeight = (value) =>
  value && Number(value) > 0 ? `${value} g` : null;

export const formatComponents = (components) => {
  if (!Array.isArray(components) || !components.length) {
    return null;
  }
  return components
    .map(({ name, materials }) => {
      const materialsLabel = (materials || []).map(materialLabel).join(", ");
      return materialsLabel ? `${name || "?"}: ${materialsLabel}` : name || "?";
    })
    .join("; ");
};

export const formatMaterialsList = (materials) => {
  if (!Array.isArray(materials) || !materials.length) {
    return null;
  }
  return materials.map(materialLabel).join(", ");
};

export const formatElectronics = (electronics) => {
  if (!electronics || !Object.keys(electronics).length) {
    return null;
  }
  const { capacityMAh, voltage } = electronics;
  if (capacityMAh && voltage) {
    return `${capacityMAh} mAh, ${voltage}V battery`;
  }
  return "Specs recorded";
};

const destinationLabel = (destination) => {
  const cityCountry = [destination?.city, destination?.country]
    .filter(Boolean)
    .join(", ");
  return (
    destination?.address ||
    destination?.description ||
    destination?.name ||
    destination?.label ||
    cityCountry ||
    "?"
  );
};

const formatSimpleRoute = ({ origin, destination, mode }) => {
  const endpoints = [origin, destination].filter(Boolean);
  if (!endpoints.length) {
    return null;
  }
  const path = endpoints.join(" → ");
  return mode ? `${path} (${mode})` : path;
};

export const formatRoute = (route) => {
  if (!route) {
    return null;
  }
  if (route.origin || route.destination || route.mode) {
    return formatSimpleRoute(route);
  }
  const destinations = route.destinations || [];
  const legs = route.legs || [];
  if (!destinations.length) {
    return null;
  }
  const path = destinations.map(destinationLabel).join(" → ");
  const methods = legs.map(({ transportationMethod }) => transportationMethod)
    .filter(Boolean)
    .join(", ");
  return methods ? `${path} (${methods})` : path;
};

export const formatPackaging = (packaging, packagingWeight) => {
  if (Number(packagingWeight) === 0 && (!Array.isArray(packaging) || !packaging.length)) {
    return "No packaging (0g)";
  }
  return formatMaterialsList(packaging);
};
